import {Action, createReducer, on} from '@ngrx/store';


export const userFeatureKey = 'user';

export interface UserState {
  isLoggedIn: boolean;
  userData: any;
}

export const initialState: UserState = {
  isLoggedIn: false,
  userData: null
};


export const reducer = createReducer(
  initialState,
);

